var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" AWS SES"),_c('br'),_c('button',{staticClass:"btn-small alert",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('promptDeleteSuppression')}}},[_vm._v(" Remove from the suppression list ")])])}
var staticRenderFns = []

export { render, staticRenderFns }